<template>
	<div class="skumanagement">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys"></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">SKU管理</div>
					<div class="contentcard">
						<div style="padding-bottom: 50px;">
							<div>
								<a-button type="primary" style="width: 96px;margin-bottom: 15px;" @click="newskubtn">新增商品</a-button>
								<div>
									<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
										<a-col :span="2" style="text-align: center;">商品名</a-col>
										<a-col :span="2" style="text-align: center;">提成数</a-col>
										<a-col :span="2" style="text-align: center;">货损扣除数</a-col>
										<a-col :span="2" style="text-align: center;">业务占比</a-col>
										<a-col :span="2" style="text-align: center;">支撑占比</a-col>
										<a-col :span="2" style="text-align: center;">操作</a-col>
									</a-row>
								</div>
								<div v-if="!skulist.length">
									<a-alert message="查询结果为空" banner type="info" />
								</div>
								<div style="color: #666;font-size: 14px;" v-for="sku in skulist" :key="sku.id" v-if="skulist.length">
									<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px 0;">
										<a-col :span="2" style="text-align: center;">{{sku.sku_name}}</a-col>
										<a-col :span="2" style="text-align: center;">￥{{sku.sale_price/100}}</a-col>
										<a-col :span="2" style="text-align: center;">￥{{sku.damage_price/100}}</a-col>
										<a-col :span="2" style="text-align: center;">{{sku.operate_ratio/100+"%"}}</a-col>
										<a-col :span="2" style="text-align: center;">{{sku.technical_ratio/100+"%"}}</a-col>
										<a-col :span="2" style="text-align: center;">
											<a-button type="link" size="small" @click="bianjibtn(sku)">修改</a-button>
										</a-col>
									</a-row>
								</div>
							</div>
							<div style="float: right;position: relative;bottom: -18px;">
								<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize"
								 :total="skusum" showQuickJumper @change="pageChange" />
							</div>
						</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>

		<a-modal title="新增商品" :visible="newskuvisible" @ok="newskuOk" :confirmLoading="confirmLoading" @cancel="newskuCancel">
			<div class="newsku"><span class="newskutext">商品名称</span>
				<a-input style="width: 250px;" v-model="newsku.sku_name" placeholder="请输入商品名称" />
			</div>
			<div class="newsku"><span class="newskutext">提成数</span>
				<a-input style="width: 250px;" v-model="newsku.sale_price" placeholder="请输入提成数" />
			</div>
			<div class="newsku"><span class="newskutext">货损扣除数</span>
				<a-input style="width: 250px;" v-model="newsku.damage_price" placeholder="请输入货损扣除数" />
			</div>
			<div class="newsku"><span class="newskutext">业务占比</span>
				<a-input style="width: 250px;" v-model="newsku.operate_ratio" placeholder="请输入业务占比" />
			</div>
			<div class="newsku"><span class="newskutext">支撑占比</span>
				<a-input style="width: 250px;" v-model="newsku.technical_ratio" placeholder="请输入支撑占比" />
			</div>
		</a-modal>

		<a-modal title="商品修改" :visible="bianjivisible" @ok="bianjiOk" :confirmLoading="confirmLoading" @cancel="bianjiCancel">
			<div class="newsku"><span class="newskutext">提成数</span>
				<a-input style="width: 250px;" v-model="bianjisku.sale_price" placeholder="请输入提成数" />
			</div>
			<div class="newsku"><span class="newskutext">货损扣除数</span>
				<a-input style="width: 250px;" v-model="bianjisku.damage_price" placeholder="请输入货损扣除数" />
			</div>
			<div class="newsku"><span class="newskutext">业务占比</span>
				<a-input style="width: 250px;" v-model="bianjisku.operate_ratio" placeholder="请输入业务占比" />
			</div>
			<div class="newsku"><span class="newskutext">支撑占比</span>
				<a-input style="width: 250px;" v-model="bianjisku.technical_ratio" placeholder="请输入支撑占比" />
			</div>
		</a-modal>

	</div>
</template>

<script>
	import * as math from "mathjs/lib/cjs"
	export default {

		data() {
			return {
				current: ['salemainpage'],
				openKeys: [''],
				skulist: [],
				skusum: 0,
				startpage: this.$route.query.startpage || 0,
				endpage: this.$route.query.endpage || 10,
				pageSize: Number(this.$route.query.pageSize) || 10,
				bianjivisible: false,
				newskuvisible: false,
				confirmLoading: false,
				newsku: {
					sku_name: null,
					sale_price: null,
					damage_price: null,
					operate_ratio: null,
					technical_ratio: null
				},
				bianjisku: {
					sale_price: null,
					damage_price: null,
					operate_ratio: null,
					technical_ratio: null
				}
			}
		},
		created: function() {
			this.initialize();
		},
		methods: {
			initialize() {
				var self = this;
				var params = {
					startpage: this.startpage,
					pageSize: this.pageSize,
				};
				this.$axios.get('/sale/getsku', {
					params: params
				}).then(function(res) {
					self.skulist = res.data.skulist;
					self.skusum = res.data.skusum;

				});
			},
			onShowSizeChange(current, pageSize) {
				this.pageSize = pageSize;
				this.startpage = this.pageSize * (current - 1);
				this.endpage = this.pageSize * current;
				this.initialize();
				this.$router.push({
					name: 'skumanagement',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage
					}
				})
			},
			pageChange(pageNumber) {
				this.startpage = this.pageSize * (pageNumber - 1);
				this.endpage = this.pageSize * pageNumber;
				this.initialize();
				this.$router.push({
					name: 'skumanagement',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage
					}
				})
			},
			newskubtn() {
				this.newskuvisible = true;
			},
			newskuOk(e) {
				var self = this;
				if (!this.newsku.sku_name) {
					return this.$message.error("商品名称不能为空");
				}
				if (!this.newsku.sale_price) {
					return this.$message.error("提成数不能为空");
				}
				if (!this.newsku.damage_price) {
					return this.$message.error("货损扣除数不能为空");
				}
				if (!this.newsku.operate_ratio) {
					return this.$message.error("业务占比不能为空");
				}
				if (!this.newsku.technical_ratio) {
					return this.$message.error("支撑占比不能为空");
				}
				if ((Number(this.newsku.operate_ratio) + Number(this.newsku.technical_ratio) != 100)) {
					return this.$message.error("请调整业务与支撑占比");
				}

				var temp = {
					sku_name: this.newsku.sku_name,
					sale_price: Number(math.format(math.multiply(this.newsku.sale_price, 100), {
						precision: 14
					})),
					damage_price: Number(math.format(math.multiply(this.newsku.damage_price, 100), {
						precision: 14
					})),
					operate_ratio: Number(math.format(math.multiply(this.newsku.operate_ratio, 100), {
						precision: 14
					})),
					technical_ratio: Number(math.format(math.multiply(this.newsku.technical_ratio, 100), {
						precision: 14
					})),
					is_old: false
				}
				this.confirmLoading = true;
				this.$confirm({
					title: '提示',
					content: '是否新增商品',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/sale/savenewsku', {
							params: temp
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.confirmLoading = false;
							self.newskuvisible = false;
							self.newsku = {
								sku_name: null,
								sale_price: null,
								damage_price: null,
								operate_ratio: null,
								technical_ratio: null
							};
							self.initialize();
						});
					},
					onCancel() {
						self.confirmLoading = false;
					},
				});
			},
			newskuCancel(e) {
				this.newskuvisible = false;
				this.newsku = {
					sku_name: null,
					sale_price: null,
					damage_price: null,
					operate_ratio: null,
					technical_ratio: null
				}
			},
			bianjibtn(sku) {
				this.bianjisku = {
					id: sku.id,
					sale_price: sku.sale_price / 100,
					damage_price: sku.damage_price / 100,
					operate_ratio: sku.operate_ratio / 100,
					technical_ratio: sku.technical_ratio / 100
				};
				this.bianjivisible = true;
			},
			bianjiOk(e) {
				var self = this;
				if (!this.bianjisku.sale_price) {
					return this.$message.error("提成数不能为空");
				}
				if (!this.bianjisku.damage_price) {
					return this.$message.error("货损扣除数不能为空");
				}
				if (!this.bianjisku.operate_ratio) {
					return this.$message.error("业务占比不能为空");
				}
				if (!this.bianjisku.technical_ratio) {
					return this.$message.error("支撑占比不能为空");
				}
				if ((Number(this.bianjisku.operate_ratio) + Number(this.bianjisku.technical_ratio) != 100)) {
					return this.$message.error("请调整业务与支撑占比");
				}
				var temp = {
					id: this.bianjisku.id,
					sale_price: Number(math.format(math.multiply(this.bianjisku.sale_price, 100), {
						precision: 14
					})),
					damage_price: Number(math.format(math.multiply(this.bianjisku.damage_price, 100), {
						precision: 14
					})),
					operate_ratio: Number(math.format(math.multiply(this.bianjisku.operate_ratio, 100), {
						precision: 14
					})),
					technical_ratio: Number(math.format(math.multiply(this.bianjisku.technical_ratio, 100), {
						precision: 14
					}))
				}
				this.confirmLoading = true;
				this.$confirm({
					title: '提示',
					content: '是否保存修改',
					okText: '确认',
					cancelText: '取消',
					onOk() {
						self.$axios.post('/sale/saveoldsku', {
							params: temp
						}).then(function(res) {
							self.$notification.open({
								message: '通知',
								description: res.data,
								onClose: close,
							});
							self.confirmLoading = false;
							self.bianjivisible = false;
							self.initialize();
						});
					},
					onCancel() {
						self.confirmLoading = false;
					},
				});
			},
			bianjiCancel(e) {
				this.bianjivisible = false;
			},
		},

	};
</script>

<style>
	.skumanagement .contentcard {
		padding: 24px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}

	.newsku {
		margin-left: 30px;
		margin-bottom: 10px;
	}

	.newsku .newskutext {
		width: 100px;
		font-weight: 700;
		display: inline-block;
	}
</style>



// WEBPACK FOOTER //
// index.vue?e19c9790